import React from 'react';
import { StrategistV2 } from '../../stages/StrategistV2';
import { Stage1aKeywordsV2 } from '../../stages/Stage1aKeywordsV2';
import { Stage1bSemrushV2 } from '../../stages/Stage1bSemrushV2';
import { Stage2aSerpV2 } from '../../stages/Stage2aSerpV2';
import { Stage2bCompetitorPlanV2 } from '../../stages/Stage2bCompetitorPlanV2';
import { Stage2cCompetitorExtractV2 } from '../../stages/Stage2cCompetitorExtractV2';
import { Stage2dAggregateV2 } from '../../stages/Stage2dAggregateV2';
import { Stage2eInternalLinksV2 } from '../../stages/Stage2eInternalLinksV2';
import { Stage3aBriefV2 } from '../../stages/Stage3aBriefV2';
import { Stage4aResearchV2 } from '../../stages/Stage4aResearchV2';
import { Stage4bSectionDraftingV2 } from '../../stages/Stage4bSectionDraftingV2';
import { Stage4cFinalizeV2 } from '../../stages/Stage4cFinalizeV2';
import { Stage5CtaV2 } from '../../stages/Stage5CtaV2';
import { Stage6SeoV2 } from '../../stages/Stage6SeoV2';
import { Stage6bEditorialReviewV2 } from '../../stages/Stage6bEditorialReviewV2';
import { Stage7ImageV2 } from '../../stages/Stage7ImageV2';
import { Stage7cFinalPolishV2 } from '../../stages/Stage7cFinalPolishV2';
import { Stage8WpPublishV2 } from '../../stages/Stage8WpPublishV2';
import { Stage9AiQueriesV2 } from '../../stages/Stage9AiQueriesV2';
import { Stage10ConfirmedPublishedV2 } from '../../stages/Stage10ConfirmedPublishedV2';
import { RefreshAuditV2 } from '../../stages/RefreshAuditV2';
import { RefreshSerpV2 } from '../../stages/RefreshSerpV2';
import { RefreshLinksV2 } from '../../stages/RefreshLinksV2';
import { RefreshCompetitorExtractV2 } from '../../stages/RefreshCompetitorExtractV2';
import { RefreshCompetitorSynthesizeV2 } from '../../stages/RefreshCompetitorSynthesizeV2';
import { RefreshBriefV2 } from '../../stages/RefreshBriefV2';
import { RefreshResearchV2 } from '../../stages/RefreshResearchV2';
import { RefreshDraftingV2 } from '../../stages/RefreshDraftingV2';
import { RefreshAssemblyV2 } from '../../stages/RefreshAssemblyV2';
import { RefreshImageV2 } from '../../stages/RefreshImageV2';
import { RefreshCtaV2 } from '../../stages/RefreshCtaV2';
import { RefreshSeoV2 } from '../../stages/RefreshSeoV2';
import { RefreshEditorialReviewV2 } from '../../stages/RefreshEditorialReviewV2';
import { RefreshFinalPolishV2 } from '../../stages/RefreshFinalPolishV2';
import { RefreshPublishV2 } from '../../stages/RefreshPublishV2';

export const STAGE_COMPONENTS: Record<string, React.FC> = {
  stage_targeting_strategist: StrategistV2,
  stage_1a_keywords: Stage1aKeywordsV2,
  stage_1b_semrush: Stage1bSemrushV2,
  stage_2a_serp_overview: Stage2aSerpV2,
  stage_2b_competitor_plan: Stage2bCompetitorPlanV2,
  stage_2c_competitor_extract: Stage2cCompetitorExtractV2,
  stage_2d_competitor_aggregate: Stage2dAggregateV2,
  stage_2e_internal_links: Stage2eInternalLinksV2,
  stage_3a_brief: Stage3aBriefV2,
  stage_4a_research_enrichment: Stage4aResearchV2,
  stage_4b_section_drafting: Stage4bSectionDraftingV2,
  stage_4c_research_finalize: Stage4cFinalizeV2,
  stage_5_cta_placement: Stage5CtaV2,
  stage_6_seo_validation: Stage6SeoV2,
  stage_6b_editorial_review: Stage6bEditorialReviewV2,
  stage_7_image_generation: Stage7ImageV2,
  stage_7c_final_polish: Stage7cFinalPolishV2,
  stage_8_wp_publish: Stage8WpPublishV2,
  stage_9_ai_queries: Stage9AiQueriesV2,
  stage_10_confirmed_published: Stage10ConfirmedPublishedV2,
  refresh_1_audit: RefreshAuditV2,
  refresh_2_serp: RefreshSerpV2,
  refresh_3_competitor_extract: RefreshCompetitorExtractV2,
  refresh_4_competitor_synthesize: RefreshCompetitorSynthesizeV2,
  refresh_5_links: RefreshLinksV2,
  refresh_6_brief: RefreshBriefV2,
  refresh_7_research: RefreshResearchV2,
  refresh_8_drafting: RefreshDraftingV2,
  refresh_9_assembly: RefreshAssemblyV2,
  refresh_9b_image: RefreshImageV2,
  refresh_10_cta: RefreshCtaV2,
  refresh_11_seo: RefreshSeoV2,
  refresh_11b_editorial_review: RefreshEditorialReviewV2,
  refresh_11c_polish: RefreshFinalPolishV2,
  refresh_12_publish: RefreshPublishV2,
};
